import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

// Exportar a PDF
export const exportToPDF = (title, headers, data, filename) => {
  const doc = new jsPDF();
  
  // Título
  doc.setFontSize(16);
  doc.text(title, 14, 20);
  
  // Fecha
  doc.setFontSize(10);
  doc.text(`Fecha: ${new Date().toLocaleString('es-PE')}`, 14, 28);
  doc.text(`Empresa: EJARAD-TIC - Piura, Perú`, 14, 33);
  
  // Tabla
  autoTable(doc, {
    head: [headers],
    body: data,
    startY: 40,
    theme: 'grid',
    headStyles: { fillColor: [25, 118, 210], textColor: 255 },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    styles: { fontSize: 9, cellPadding: 2 },
  });
  
  // Pie de página
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.text(`Página ${i} de ${pageCount}`, 14, doc.internal.pageSize.height - 10);
    doc.text('Sistema EJARAD-TIC - Gestión Comercial 2026', doc.internal.pageSize.width - 80, doc.internal.pageSize.height - 10);
  }
  
  doc.save(`${filename}.pdf`);
};

// Exportar a Excel
export const exportToExcel = (data, filename, sheetName = 'Datos') => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  
  // Ajustar anchos de columna
  const maxWidth = 30;
  const cols = Object.keys(data[0] || {}).map(key => ({
    wch: Math.min(Math.max(key.length, 10), maxWidth)
  }));
  worksheet['!cols'] = cols;
  
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};